// extracted by mini-css-extract-plugin
export var sliderRange = "_ot-2";
export var sliderRoot = "_ot-0";
export var sliderThumb = "_ot-3";
export var sliderTrack = "_ot-1";